import React, { useState, useRef } from 'react';
import Button from 'components/form/Button';
import Modal from 'components/Layout/Modal';
import { icons } from 'utils/constants';
import { showSuccess } from 'store/slices';
import { useDispatch } from 'react-redux';

const IframePopup = ({ shareURL, onHide }) => {
    const dispatch = useDispatch();
    const [isCopied, setIsCopied] = useState(false);
    const textareaRef = useRef(null);

    const iframeCode = `<!-- Place this iframe inside the <body> tag of your page -->
<iframe
id="abstractIframe"
src="${shareURL}"
width="100%"
height="700"
style="border: none; overflow: hidden;"
allowfullscreen
loading="lazy"
referrerpolicy="no-referrer-when-downgrade">
</iframe>

<!-- Place this script inside a <script> tag just before the closing </body> tag -->
<script>
window.addEventListener("message", (event) => {
    if (event.data && event.data.iframeHeight) {
    const iframe = document.getElementById("abstractIframe");
    if (iframe) {
        iframe.style.height = event.data.iframeHeight + "px";
    }
    }
});
</script>`;

    const copyToClipboard = async () => {
        try {
            if (textareaRef.current) {
                await navigator.clipboard.writeText(textareaRef.current.value);
                setIsCopied(true);
                setTimeout(() => setIsCopied(false), 1000);
                dispatch(showSuccess('Code Copied !!'));
            }
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    return (
        <Modal
            titleBesideClose="Add Iframe"
            onHide={onHide}
            isTitleBorder
            isTitleVerticalCenter
            // size="md"
            titleBesideCloseClassName="text-16-300-20"
        >
            <div className="py-4 px-3 d-flex flex-column align-items-center gap-3">
                <div className="w-100 d-flex flex-column">
                    <label className="mb-2 text-muted">
                        Copy and paste this code into your website:
                    </label>
                    <textarea
                        ref={textareaRef}
                        className="form-control text-monospace"
                        rows={10}
                        value={iframeCode}
                        readOnly
                        style={{ resize: 'none' }}
                    />
                    <Button
                        text={isCopied ? 'Copied!' : 'Copy Code'}
                        icon={
                            <img
                                src={icons.copyIcon}
                                height={15}
                                width={15}
                                className="me-2"
                                alt="Copy icon"
                            />
                        }
                        btnStyle="primary-light-outline"
                        className="mt-3 align-self-end text-truncate"
                        onClick={() => !isCopied && copyToClipboard()}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default IframePopup;


// import React, { useState, useRef } from 'react';
// import Button from 'components/form/Button';
// import Modal from 'components/Layout/Modal';
// import { icons } from 'utils/constants';
// import { showSuccess } from 'store/slices';
// import { useDispatch } from 'react-redux';

// const IframePopup = ({ shareURL, onHide }) => {
//     const dispatch = useDispatch()
//     const [isCopied, setIsCopied] = useState(false);
//     const inputRef = useRef(null);

//     const copyToClipboard = async () => {
//         try {
//             if (inputRef.current) {
//                 await navigator.clipboard.writeText(inputRef.current.value);
//                 setIsCopied(true);
//                 setTimeout(() => setIsCopied(false), 1000);
//                 dispatch(showSuccess('Code Copied !!'))
//             }
//         } catch (err) {
//             console.error('Failed to copy:', err);
//         }
//     };

//     return (
//         <Modal
//             titleBesideClose="Add Iframe"
//             onHide={onHide}
//             isTitleBorder
//             isTitleVerticalCenter
//             size="md"
//             titleBesideCloseClassName="text-16-300-20"
//         >
//             <div className="py-4 px-3 d-flex flex-column align-items-center gap-3">
//                 <div className="w-100 d-flex flex-column flex-md-row align-items-center gap-2">
//                     <input
//                         ref={inputRef}
//                         className="form-control flex-grow-1 text-truncate"
//                         value={`<iframe src="${shareURL}"  width="100%" height="700" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`}
//                         readOnly
//                     />
//                     <Button
//                         text={isCopied ? 'Copied!' : 'Copy Code'}
//                         icon={
//                             <img
//                                 src={icons.copyIcon}
//                                 height={15}
//                                 width={15}
//                                 className="me-2"
//                                 alt="Copy icon"
//                             />
//                         }
//                         btnStyle="primary-light-outline"
//                         className="mt-2 mt-md-0 h-35 text-truncate"
//                         onClick={() => !isCopied && copyToClipboard()}
//                     />
//                 </div>
//             </div>
//         </Modal>
//     );
// };

// export default IframePopup;
